import { NotFoundRoute } from "@tanstack/react-router";
import { GeneralError } from "../components";
import { rootRoute } from "./root";

export const notFoundRoute = new NotFoundRoute({
  getParentRoute: () => rootRoute,
  component: () => <GeneralError className="h-screen" />, //TODO: we should ask designer for a 404 error page
});
